import angular from 'angular';
import moment from 'moment';
import 'moment-pl';
import 'ui-select';
import 'admin/apps/appsServices';
import '../../application/webpages/webPagesServices';
import '../../application/webmodules/webModulesServices';
import '../../application/webmodules/webModulesControllers';

/**
 * @ngdoc overview
 * @name commonModule.nav
 * @description
 * # commonModule.nav
 * Module for managing the common directives.
 */
const nav = angular.module('commonModule.nav', [
    'adminModule.appsServices',
    'applicationModule.webModulesControllers',
    'applicationModule.webModulesServices',
    'applicationModule.webPagesServices',
    'ui.select'
]);
/**
 * @ngdoc directive
 * @name commonModule.nav.directive:sidebarMenu
 * @description
 * Directive for sidebar menu of the panel
 */
nav.directive('sidebarMenu', function () {
    'use strict';
    return {
        restrict: 'A',
        templateUrl: 'views/common/components/nav/sidebarMenu.tpl.html',
        controller: ['$scope', '$rootScope', '$state', '$modal', 'Session', 'App', 'Webpages', 'Webmodules', 'growl', 'Permissions', function ($scope, $rootScope, $state, $modal, Session, App, Webpages, Webmodules, growl, Permissions) {
            $scope.selected_id = {};
            $scope.closeMenu = function () {
                $rootScope.$broadcast('closeMenu');
            };
            $scope.applications = [];
            $scope.showMorePages = false;
            $scope.treeLoading = false;
            $scope.search = {
                pageText: ''
            };

            $scope.$on('newApp', function (event, args) {
                if (args) {
                    App.checkPermissions(args.select).then(function (response) {
                        if (!response.success) {
                            // growl.error(response.error);
                            $rootScope.$broadcast('404');
                        } else {
                            $scope.selected_id.selected = parseInt(args.select);
                            if (angular.isDefined(args.module) && !Permissions.hasWriteAccess(args.module)) {
                                // growl.error(response.error);
                                $rootScope.$broadcast('404');
                            }
                            if (angular.isDefined(args.view) && !Permissions.hasWriteAccess(args.view)) {
                                $rootScope.$broadcast('404');
                            }
                        }
                    });
                } else {
                    App.getMenu()
                        .then(function (response) {
                            if (angular.isDefined(response)) {
                                $scope.applications = response.applications.data;
                                if (response.applications.total === 1) {
                                    $scope.selected_id.selected = response.applications.data[0].id;
                                }
                            }
                        });
                }
            });

            $scope.getCollapsedClass = function (collapse) {
                if (collapse) {
                    $scope.isCollapsed = false;
                } else {
                    $scope.isCollapsed = true;
                }
            };

            $scope.showMorePagesTree = function () {
                $scope.treeLoading = true;
                $scope.showMorePages = !$scope.showMorePages;
                var limit = 10;
                if ($scope.showMorePages) {
                    limit = null;
                }
                Webpages.tree($scope.selected_id.selected, limit)
                    .then(function (response) {
                        $scope.pages = response.pages;
                        $scope.sections = response.sections;
                        $scope.modules = response.modules;
                        $scope.treeLoading = false;
                        $scope.searchPageText = '';
                    });
            };

            $scope.$watch('showMorePages', function () {
                delete $scope.search.pageText;
            });

            $scope.searchPage = function (search) {
                if (search != '') {
                    search = search.toLowerCase();
                    $scope.showMorePages = false;
                }
                $scope.treeLoading = true;
                var limit = null;
                Webpages.tree($scope.selected_id.selected, limit, search)
                    .then(function (response) {
                        $scope.pages = response.pages;
                        $scope.sections = response.sections;
                        $scope.modules = response.modules;
                        $scope.treeLoading = false;
                    });
            };

            $scope.clearSearch = function () {
                $scope.treeLoading = true;
                $scope.search.pageText = '';
                var limit = 10;
                Webpages.tree($scope.selected_id.selected, limit)
                    .then(function (response) {
                        $scope.pages = response.pages;
                        $scope.sections = response.sections;
                        $scope.modules = response.modules;
                        $scope.treeLoading = false;
                        $scope.searchPageText = '';
                    });
            };

            $scope.$on('wwwStructure', function (event, args) {
                $scope.treeLoading = true;
                $scope.showMorePages = false;
                delete $scope.search.pageText;
                var limit = null;
                if (angular.isDefined(args.limit)) {
                    limit = args.limit;
                }
                Webpages.tree(args.app, limit)
                    .then(function (response) {
                        $scope.pages = response.pages;
                        $scope.sections = response.sections;
                        $scope.modules = response.modules;
                        $scope.treeLoading = false;
                    });
            });
            $scope.$on('wwwModules', function (event, args) {
                Webmodules.listToMenu(args.app)
                    .then(function (response) {
                        $scope.webModules = response.modules;
                        $scope.webTemplates = response.templates;
                        $scope.isCollapseModulesList = false;
                        $scope.isCollapsedTemplate = {};
                    });
            });
            $scope.isActive = function (state, menuState) {
                var menuActive = state.current.menuActive;

                return state.current.name === menuState || (angular.isDefined(menuActive) && menuActive === menuState);
            };
            $scope.dates = Session.getDateStateParams();
            $scope.$on('dateChange', function () {
                $scope.dates = Session.getDateStateParams();
            });
            $scope.addModule = function (module) {
                var content = $('#content').offset();
                $('html, body').animate({scrollTop: content.top}, "slow");
                var modalInstance = $modal.open({
                    templateUrl: 'views/application/web/modules/add.tpl.html',
                    controller: 'AddWebModuleModalController',
                    resolve: {
                        module: function () {
                            return module;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.CREATED');
                }).catch(() => {});
            };

            $scope.$watch('selected_id.selected', function (newVal, oldVal) {
                if (newVal && oldVal && (newVal !== oldVal)) {
                    if ($state.$current.self.ncyBreadcrumb && $state.$current.self.ncyBreadcrumb.parent) {
                        $state.go($state.$current.self.ncyBreadcrumb.parent, {application_id: $scope.selected_id.selected});
                    } else {
                        $state.go($state.current, {application_id: $scope.selected_id.selected});
                    }
                }
            });
        }]
    };
});
/**
 * @ngdoc directive
 * @name commonModule.nav.directive:menuItemGroup
 * @description
 * Directive for group in the menu (collapsible)
 */
nav.directive('menuItemGroup', function () {
    'use strict';
    return {
        restrict: 'A',
        scope: true,
        controller: ['$scope', '$rootScope', '$state', '$stateParams', 'Webmodules', '$modal', 'growl', function ($scope, $rootScope, $state, $stateParams, Webmodules, $modal, growl) {
            $scope.webPageId = $stateParams.page_id;
            $scope.isCollapsed = angular.isNullOrUndefined($stateParams.page_id);
            $scope.data = {
                collapse: false
            };
            if (angular.isDefinedNotNull($stateParams.section_id)) {
                $scope.isCollapsedSection = [];
                $scope.isCollapsedSection[$stateParams.section_id] = true;
            }
            $scope.toggleCollapse = function () {
                if ($scope.isCollapsed) {
                    $rootScope.$broadcast('closeMenu');
                }
                $scope.isCollapsed = !$scope.isCollapsed;
                $scope.data.collapse = !$scope.data.collapse;
                $scope.$on('closeMenu', function () {
                    $scope.isCollapsed = true;
                });
            };
            $scope.test = function () {
                $scope.isCollapsed = !$scope.isCollapsed;
                $scope.data.collapse = !$scope.data.collapse;
            };

            $scope.getCollapsedClass = function (collapse) {
                if (collapse) {
                    $scope.isCollapsed = false;
                } else {
                    $scope.isCollapsed = true;
                }
            };

            $scope.openElement = function () {
                $rootScope.$broadcast('closeMenu');
                $scope.isCollapsed = false;
            };
            $scope.routeTo = function ($event, state, params) {
                $event.stopImmediatePropagation();
                if (angular.isNullOrUndefined(params.page_id)) {
                    params.page_id = '';
                }
                $state.go(state, params, {reload: true});
            };
            $scope.routeToSection = function ($event, state, params) {
                $event.stopImmediatePropagation();
                if (angular.isNullOrUndefined(params.page_id)) {
                    params.page_id = '';
                }
                $state.go(state, params, {reload: true});
            };
            $scope.editWebModule = function (module, container, pageId, $event) {
                var content = $('#content').offset();
                $('html, body').animate({scrollTop: content.top}, "slow");
                $event.stopImmediatePropagation();
                Webmodules.get(module.joining_id)
                    .then(function (result) {
                        let data = result.data;

                        if (data.success) {
                            data.module.container = container;
                            var modalInstance = $modal.open({
                                templateUrl: 'views/application/web/modules/edit.tpl.html',
                                controller: 'WebModuleModalController',
                                resolve: {
                                    module: function () {
                                        return data.module;
                                    },
                                    params: function () {
                                        return {
                                            page_id: pageId,
                                            container: container
                                        };
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $state.go($state.current, {}, {reload: true});
                                growl.success('MODULES.APPLICATIONS.MODULES.WWW.MODULES.SUCCESS.EDITED');
                            }).catch(() => {});
                        }
                    });
            };
            $scope.addWebModule = function (module, pageId) {
                var content = $('#content').offset();
                $('html, body').animate({scrollTop: content.top}, "slow");
                module = {
                    id: module.key,
                    name: module.value,
                    page_id: pageId
                };
                var modalInstance = $modal.open({
                    templateUrl: 'views/application/web/modules/add.tpl.html',
                    controller: 'AddWebModuleModalController',
                    resolve: {
                        module: function () {
                            return module;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.CREATED');
                }).catch(() => {});
            };

            $scope.objectKeys = function (obj) {
                return Object.keys(obj);
            };
        }]
    };
});
nav.directive('menuItemGroupChilds', function () {
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        scope: {
            data: '=ngModel',
            sections: '=sectionsData',
            modules: '=modulesData'
        },
        templateUrl: 'views/common/components/nav/menuItemGroupChilds.tpl.html',
        controller: ['$scope', '$rootScope', '$state', '$stateParams', 'Webmodules', '$modal', 'growl', function ($scope, $rootScope, $state, $stateParams, Webmodules, $modal, growl) {
            $scope.application_id = $stateParams.application_id;
            $scope.webPageId = $stateParams.page_id;
            $scope.data.collapse = false;
            var collapseTab = [];
            $scope.setCollapse = function (page) {
                collapseTab.push((page.id).toString());
                if (page.has_children) {
                    angular.forEach(page.children, function (v) {
                        collapseTab.concat($scope.setCollapse(v));
                    });
                }

                return collapseTab;
            };
            var pageCollapse = $scope.setCollapse($scope.data);
            $scope.isCollapsed = pageCollapse.indexOf($stateParams.page_id) !== -1 ? false : true;
            $scope.isCollapsedContainer = {};
            $scope.test = function () {
                $scope.isCollapsed = !$scope.isCollapsed;
                $scope.data.collapse = !$scope.data.collapse;
            };

            $scope.getCollapsedClass = function (collapse) {
                if (collapse) {
                    $scope.isCollapsed = false;
                } else {
                    $scope.isCollapsed = true;
                }
            };

            $scope.$watch('data.collapse', function (newValue) {
                if (newValue) {
                    $scope.isCollapsed = false;
                } else {
                    $scope.isCollapsed = true;
                }
            });
            $scope.checkState = function (pageId) {
                if (angular.isNullOrUndefined($stateParams.page_id)) {
                    return false;
                } else if ($stateParams.page_id == pageId) {
                    return true;
                }

                return false;
            };
            $scope.routeTo = function ($event, state, params) {
                $event.stopImmediatePropagation();
                $state.go(state, params, {reload: true});
            };

            $scope.routeToSection = function ($event, state, params) {
                $event.stopImmediatePropagation();
                if (angular.isNullOrUndefined(params.page_id)) {
                    params.page_id = '';
                }
                $state.go(state, params, {reload: true});
            };
            $scope.editWebModule = function (module, container, pageId, $event) {
                var content = $('#content').offset();
                $('html, body').animate({scrollTop: content.top}, "slow");
                $event.stopImmediatePropagation();
                Webmodules.get(module.joining_id)
                    .then(function (result) {
                        let data = result.data;

                        if (data.success) {
                            data.module.container = container;
                            var modalInstance = $modal.open({
                                templateUrl: 'views/application/web/modules/edit.tpl.html',
                                controller: 'WebModuleModalController',
                                resolve: {
                                    module: function () {
                                        return data.module;
                                    },
                                    params: function () {
                                        return {
                                            page_id: pageId,
                                            container: container
                                        };
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $state.go($state.current, {}, {reload: true});
                                growl.success('MODULES.APPLICATIONS.MODULES.WWW.MODULES.SUCCESS.EDITED');
                            }).catch(() => {});
                        }
                    });
            };
            $scope.addWebModule = function (module, pageId) {
                var content = $('#content').offset();
                $('html, body').animate({scrollTop: content.top}, "slow");
                module = {
                    id: module.key,
                    name: module.value,
                    page_id: pageId
                };
                var modalInstance = $modal.open({
                    templateUrl: 'views/application/web/modules/add.tpl.html',
                    controller: 'AddWebModuleModalController',
                    resolve: {
                        module: function () {
                            return module;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.CREATED');
                }).catch(() => {});
            };

            $scope.objectKeys = function (obj) {
                return Object.keys(obj);
            };
        }]
    };
});
nav.directive('menuItemGroupChildsWrapper', function ($compile) {
    'use strict';
    return {
        restrict: 'A',
        replace: true,
        scope: {
            data: '=ngModel',
            sections: '=sectionsData',
            modules: '=modulesData'
        },
        link: function (scope, element) {
            if (scope.data.has_children) {
                element.append("<li ng-repeat='data in data.children| orderBy: order' ng-model='data' modules-data='modules' sections-data='sections' menu-item-group-childs>");
                $compile(element.contents())(scope);
            }
        }
    };
});
/**
 * @ngdoc directive
 * @name commonModule.nav.directive:appsoupNav
 * @description
 * Directive for top header Appsoup Navigation
 */
nav.directive('appsoupNav', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        templateUrl: 'views/common/components/nav/header.tpl.html',
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
            $scope.menu = {compact: false, compact2: false};
            $scope.toggleMenu = function () {
                $scope.menu.compact = !$scope.menu.compact;
            };
            $scope.toggleMenu2 = function () {
                $scope.menu.compact2 = !$scope.menu.compact2;
            };
            $scope.isActive = function (state, menuState) {
                var menuActive = state.current.menuActive;

                return state.current.name === menuState || (angular.isDefined(menuActive) && menuActive === menuState);
            };
            $scope.$watch('menu.compact', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $rootScope.$broadcast('updateMaps');
                }
            });
        }]
    };
});
/**
 * @ngdoc directive
 * @name commonModule.nav.directive:appsoupNav
 * @description
 * Directive for top header Appsoup Navigation
 */
nav.directive('appsoupFooter', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        template: '<footer id="footer" class="app-footer {{newClass()}}" role="footer"><div class="wrapper b-t bg-light"> &copy; {{currentYear}}</div></footer>',
        controller: ['$scope', '$state', function ($scope, $state) {
            $scope.currentYear = moment().year();
            $scope.isActive = function (state, menuState) {
                var menuActive = state.current.menuActive;

                return state.current.name === menuState || (angular.isDefined(menuActive) && menuActive === menuState);
            };
            $scope.newClass = function () {
                if ($scope.isActive($state, 'appsoup.application.webpages')) {
                    return "app-footer2";
                }
                if ($scope.isActive($state, 'appsoup.application.webelements')) {
                    return "app-footer2";
                }
                if ($scope.isActive($state, 'appsoup.application.webSectionNew')) {
                    return "app-footer2";
                }
                if ($scope.isActive($state, 'appsoup.application.webSectionEdit')) {
                    return "app-footer2";
                }

                return "";
            };
        }]
    };
});
/**
 * @ngdoc directive
 * @name commonModule.nav.directive:appsoupTitle
 * @description
 * Directive for displaying the <title> meta tag for pages
 */
nav.directive('appsoupTitle', function () {
    'use strict';
    return {
        restrict: 'A',
        controller: ['$scope', '$rootScope', '$breadcrumb', '$timeout', '$translate', function ($scope, $rootScope, $breadcrumb, $timeout, $translate) {
            $rootScope.$on('$viewContentLoaded', function () {
                $timeout(function () {
                    var lastStep = $breadcrumb.getLastStep();
                    if (angular.isDefined(lastStep.ncyBreadcrumb)) {
                        $scope.pageTitle = $translate.instant(lastStep.ncyBreadcrumb.label);
                    }
                    if (angular.isUndefinedNullOrEmpty($scope.pageTitle)) {
                        var string = lastStep.ncyBreadcrumb.label;
                        string = string.replace('{{', '');
                        string = string.replace('}}', '');
                        string = string.split(".");
                        var lastScope = $breadcrumb.$getLastViewScope();
                        if (angular.isDefined(string[0]) && angular.isDefined(string[1])
                            && angular.isDefined(lastScope[string[0]])) {
                            $scope.pageTitle = lastScope[string[0]][string[1]];
                        }
                    }
                }, 1000);
            });
        }],
        template: '{{pageTitle ? (pageTitle) : "" }}'
    };
});

export default nav;
